// @flow
import React from "react";
import { connect } from "react-redux";
import Actions from "../../actions/Creators";
import moment from "moment";
import _ from "lodash";
import {
  Layout,
  ToggleButton,
  Loader,
  EmptyResults,
  Pagination,
  Timer
} from "../../components/common/";
import CONFIG from "../../config";
import Helper from "../../helper/Helper";
import OrderTable from "../../components/common/orderTable/OrderTable";
import ReservedItems from "../../components/orders/reservedItems/ReservedItems";
import OrderDetails from "../../components/orders/orderDetails/OrderDetails";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import I18n from "../../i18n/I18n";
import VatNotification from "../../components/vatNotification/VatNotification";
import styles from "./Orders.scss";

class Home extends React.Component {
  state: {
    currentPage: Number
  };
  constructor() {
    super();

    this.state = {
      currentPage: 1,
      ordersType: "0",
      itemPerPage: 20,
      statusFilter: "All",
      businessModel: "5",
      key: "",
      dir: "",
      hrs: ""
    };

    this.onOrderSelect = this.onOrderSelect.bind(this);
    this.onBack = this.onBack.bind(this);
    this.toggleType = this.toggleType.bind(this);
    this.statusChange = this.statusChange.bind(this);
    this.changeBusinessModel = this.changeBusinessModel.bind(this);
    this.perPage = this.perPage.bind(this);
    this.printOrderDetails = this.printOrderDetails.bind(this);
    this.sortColumn = this.sortColumn.bind(this);
  }
  componentDidMount() {
    if (this.props.user && this.props.seller) {
      this.props.match.params.poNr
        ? this.getOrderDetails(this.props.match.params.poNr)
        : this.getOrdersData(
            this.state.itemPerPage,
            this.state.currentPage,
            this.state.statusFilter,
            this.state.businessModel
          );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.match !== nextProps.match ||
      this.props.seller !== nextProps.seller
    ) {
      nextProps.match.params.poNr
        ? this.getOrderDetails(nextProps.match.params.poNr)
        : this.getOrdersData(
            this.state.itemPerPage,
            this.state.currentPage,
            this.state.statusFilter,
            this.state.businessModel
          );
    }
  }

  getOrdersData(
    limits,
    page,
    orderStatus,
    businessModel,
    ordersType,
    key,
    dir,
    search
  ) {
    let query = `limits=${limits}&page=${page}`;
    query =
      orderStatus && orderStatus !== "All"
        ? `${query}&order_status=${orderStatus}`
        : query;
    query =
      businessModel && businessModel !== "5"
        ? `${query}&business_model=${businessModel}`
        : query;
    query = key ? `${query}&sort=${key}` : query;
    query = key && dir ? `${query}&dir=${dir}` : query;
    query = search ? `${query}&search=${search}` : query;
    if (ordersType === "1") {
      this.props.dispatch(Actions.getReservedOrders());
    } else {
      this.props.dispatch(Actions.getOrders(query));
    }
  }

  onSearch = search => {
    if (this.props.match.params.poNr) {
      this.props.history.push(`/${Helper.getLocale()}/orders/`);
    }
    this.getOrdersData(
      this.state.itemPerPage,
      1,
      null,
      null,
      null,
      null,
      null,
      search
    );
    var newState = {};
    newState["currentPage"] = 1;
    this.setState(newState);
  };

  getOrderDetails(poNr) {
    const query = `poNr=${poNr}`;
    this.props.dispatch(Actions.getOrders(query));
  }

  printOrderDetails(poNr) {
    const query = `poNr=${poNr}`;
    this.props.dispatch(Actions.printOrder(query));
  }

  onOrderSelect(poNr) {
    this.props.history.push(`/${Helper.getLocale()}/orders/${poNr}`);
    this.getOrderDetails(poNr);
  }

  onBack() {
    this.props.history.push(`/${Helper.getLocale()}/orders/`);
    this.getOrdersData(
      this.state.itemPerPage,
      1,
      this.state.statusFilter,
      this.state.businessModel
    );
    this.setState({
      ordersType: "0",
      currentPage: 1
    });
  }

  toggleType = ordersType => {
    this.getOrdersData(
      this.state.itemPerPage,
      1,
      this.state.statusFilter,
      this.state.businessModel,
      String(Number(ordersType) - 1)
    );
    this.setState({
      ordersType: String(Number(ordersType) - 1),
      currentPage: 1
    });
  };

  onAcceptOrder = (poNr: string, offers: Object) => {
    const orders = {
      poNr: poNr,
      offers: offers
    };

    this.props.dispatch(Actions.postOrders(orders));
  };

  sortColumn(key, dir) {
    var newState = {};
    newState["key"] = key;
    newState["dir"] = dir;
    newState["currentPage"] = 1;
    this.setState(newState);
    this.getOrdersData(
      this.state.itemPerPage,
      1,
      this.state.statusFilter,
      this.state.businessModel,
      "",
      key,
      dir
    );
  }

  onPageChange = page => {
    var newState = {};
    newState["currentPage"] = page.selected + 1;
    this.setState(newState);
    this.getOrdersData(
      this.state.itemPerPage,
      page.selected + 1,
      this.state.statusFilter,
      this.state.businessModel
    );
  };

  statusChange(e) {
    var newState = {};
    newState["statusFilter"] = e;
    newState["currentPage"] = 1;
    this.setState(newState);
    this.getOrdersData(this.state.itemPerPage, 1, e, this.state.businessModel);
  }

  changeBusinessModel(e) {
    var newState = {};
    newState["businessModel"] = e;
    newState["currentPage"] = 1;
    this.setState(newState);
    this.getOrdersData(this.state.itemPerPage, 1, this.state.statusFilter, e);
  }

  perPage(e) {
    var newState = {};
    newState["itemPerPage"] = e;
    newState["currentPage"] = 1;
    this.setState(newState);
    this.getOrdersData(e, 1, this.state.statusFilter, this.state.businessModel);
  }

  timerValue = hrs => {
    this.setState({
      hrs: hrs
    });
  };

  render() {
    const poNr = this.props.match.params.poNr || null;
    const seller = this.props.seller;
    const orders = this.props.orders;
    let title = "orders.title";
    if (this.props.match.params.poNr) {
      title = "orders.detail-title";
    } else {
      if (this.state.ordersType === "1") {
        title = "orders.reserved-title";
      }
    }

    const statusOptions =
      orders &&
      orders.orders &&
      orders.orders.orders &&
      !orders.orders.orders.items
        ? [
            {
              value: "All",
              key: "All",
              label: I18n.getText("orders.All", {}, "All")
            },
            {
              value: "New",
              key: "New",
              label: I18n.getText("orders.new", {}, "New")
            },
            {
              value: "Rejected",
              key: "Rejected",
              label: I18n.getText("orders.rejected", {}, "Rejected")
            },
            {
              value: "Accepted",
              key: "Accepted",
              label: I18n.getText("orders.accepted", {}, "Accepted")
            },
            {
              value: "Rejected by noon",
              key: "Rejected by noon",
              label: I18n.getText(
                "orders.reject-by-noon",
                {},
                "Rejected by noon"
              )
            },
            {
              value: "Completed",
              key: "Completed",
              label: I18n.getText("orders.completed", {}, "Completed")
            },
            {
              value: "Accepted by noon",
              key: "Accepted by noon",
              label: I18n.getText(
                "orders.accepted-noon",
                {},
                "Accepted by noon"
              )
            },
            {
              value: "Shipped",
              key: "Shipped",
              label: I18n.getText("orders.shipped", {}, "Shipped")
            },
            {
              value: "Partially Completed",
              key: "Partially Completed",
              label: I18n.getText(
                "orders.partial-completed",
                {},
                "Partially Completed"
              )
            },
            {
              value: "Partially Shipped",
              key: "Partially Shipped",
              label: I18n.getText(
                "orders.partial-shipped",
                {},
                "Partially Shipped"
              )
            },
            {
              value: "Partially Accepted by noon",
              key: "Partially Accepted by noon",
              label: I18n.getText(
                "orders.partial-accepted-noon",
                {},
                "Partially Accepted by noon"
              )
            },
            {
              value: "Partially Accepted",
              key: "Partially Accepted",
              label: I18n.getText(
                "orders.partial-accepted",
                {},
                "Partially Accepted"
              )
            },
            {
              value: "Cancelled By Buyer",
              key: "Cancelled By Buyer",
              label: I18n.getText(
                "orders.buyer-cancelled",
                {},
                "Cancelled By Buyer"
              )
            }
          ]
        : [];
    const fulfilmentOptions =
      orders && orders.orders && orders.orders.orders
        ? [
            {
              value: "5",
              key: "5",
              label: I18n.getText("orders.fulfilment-all", {}, "All")
            },
            {
              value: "3",
              key: "3",
              label: I18n.getText("orders.by-noon", {}, "By noon")
            },
            {
              value: "4",
              key: "4",
              label: I18n.getText("orders.by-seller", {}, "By Seller")
            }
          ]
        : [];

    const pageOptions =
      orders && orders.orders && orders.orders.orders
        ? [
            {
              value: 20,
              key: 20,
              label: I18n.getText("orders.20-per-page", {}, "20 Per Page")
            },
            {
              value: 40,
              key: 40,
              label: I18n.getText("orders.40-per-page", {}, "40 Per Page")
            },
            {
              value: 60,
              key: 60,
              label: I18n.getText("orders.60-per-page", {}, "60 Per Page")
            }
          ]
        : [];

    const endDate = "Mon May 02 2018 17:00:00 GMT+0400 (+04)";

    return (
      <Layout
        currentIndex={7}
        title={title}
        onSearch={this.state.ordersType === "1" ? "" : this.onSearch}
        searchLabel={
          this.state.ordersType === "1" ? "" : "orders.top-search-placeholder"
        }
      >
        <div style={{ display: "none" }}>
          <Timer endDate={endDate} timerValue={this.timerValue} />
        </div>
        {this.props.isLoading || this.props.sessionIsLoading ? (
          <div>
            <Loader />
          </div>
        ) : (
          <div>
            {seller ? (
              <div className={styles.orderCtr}>
                <div className={styles.notCtr}>
                  <VatNotification lang={this.props.lang}>
                    {I18n.getHtml("orders.deprecated-notification", {
                      email: CONFIG.CONTACT_EMAIL,
                      hrs: this.state.hrs || "48",
                      phone:
                        seller.country_code === "SA"
                          ? CONFIG.PHONE_NUMBER_KSA
                          : CONFIG.PHONE_NUMBER
                    })}
                  </VatNotification>
                </div>
                {poNr ? (
                  <div>
                    {orders && orders.orders && orders.orders.orders ? (
                      <OrderDetails
                        data={orders.orders.orders[0]}
                        currencyCode={seller.currency_code}
                        lang={this.props.lang}
                        history={this.props.history}
                        onBack={this.onBack}
                        onAcceptOrder={this.onAcceptOrder}
                        printOrderDetails={this.printOrderDetails}
                        browser={this.props.browser}
                      />
                    ) : (
                      <EmptyResults type="order" handleBtnClick={this.onBack} />
                    )}
                  </div>
                ) : (
                  <div className={styles.orderList}>
                    <ToggleButton
                      toggleBtn={this.toggleType}
                      toggleItems={[
                        I18n.getText("orders.all-orders"),
                        I18n.getText("orders.reserved")
                      ]}
                      selected={Number(this.state.ordersType) + 1}
                    />
                    {orders && orders.orders && orders.orders.items ? (
                      <div>
                        {orders &&
                        orders.orders &&
                        orders.orders.items &&
                        orders.orders.items.length ? (
                          <ReservedItems
                            data={orders.orders.items}
                            currencyCode={seller.currency_code}
                            browser={this.props.browser}
                          />
                        ) : (
                          <EmptyResults type="reserve" />
                        )}
                      </div>
                    ) : (
                      <div>
                        <div className={styles.filterWrapper}>
                          <div className={styles.eachFilter}>
                            <Dropdown
                              onChange={this.statusChange}
                              selected={this.state.statusFilter}
                              options={statusOptions}
                              label={I18n.getText(
                                "orders.status",
                                {},
                                "Status"
                              )}
                            />
                          </div>
                          <div className={styles.eachFilter}>
                            <Dropdown
                              onChange={this.changeBusinessModel}
                              selected={this.state.businessModel}
                              options={fulfilmentOptions}
                              label={I18n.getText(
                                "orders.fulfilment-filter",
                                {},
                                "Fulfilment"
                              )}
                            />
                          </div>
                          <div className={styles.eachFilter}>
                            <Dropdown
                              onChange={this.perPage}
                              selected={this.state.itemPerPage}
                              options={pageOptions}
                              label={I18n.getText(
                                "orders.display",
                                {},
                                "Display"
                              )}
                            />
                          </div>
                        </div>
                        <div className={styles.tableWrapper}>
                          {orders &&
                          orders.orders &&
                          orders.orders.orders &&
                          !_.isEmpty(orders.orders.orders) ? (
                            <OrderTable
                              data={orders.orders.orders}
                              history={this.props.history}
                              currencyCode={seller.currency_code}
                              lang={this.props.lang}
                              onOrderSelect={this.onOrderSelect}
                              sortColumn={this.sortColumn}
                              bore={this.sortColumn}
                              keyVal={this.state.key}
                              dir={this.state.dir}
                              browser={this.props.browser}
                            />
                          ) : (
                            <EmptyResults type="orders" />
                          )}
                          {orders &&
                          orders.orders &&
                          orders.orders.no_of_pages &&
                          orders.orders.no_of_pages > 1 ? (
                            <div className={styles.paginationWrapper}>
                              <Pagination
                                pageCount={Number(orders.orders.no_of_pages)}
                                currentPage={this.state.currentPage}
                                onPageChange={this.onPageChange}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  return {
    sessionIsLoading: state.session.isLoading,
    session: state.session,
    lang: state.locale.lang,
    user: state.session.user,
    seller: state.session.seller,
    orders: state.orders,
    isLoading: state.orders.isLoading,
    browser: state.browser
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/orders/Orders.js